import React, { useState } from "react";
import { NavLink as NavigationLink } from "react-router-dom";
import clsx from "clsx";
import {
	Button,
	Container,
	Row,
	Col,
	Card,
	CardBody,
	CardText,
	CardTitle,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import events from "../data/events.json";
import PreviewCarousel from "components/preview-carousel";
import {
	Card as MaterialCard,
	CardActions,
	CardContent,
	CardHeader,
	Typography,
	Button as MaterialUIButton,
} from "@material-ui/core";
const origin_old = [
	`City@UMD’s education, research, and technology transfer
		projects explore properties emerging from the sub-scale
		processes of cities’ infrastructure. City@UMD currently has
		research activities in support of their mission funded by DOE
		and DARPA. At UMD, their work informs and serves campus
		through work with Facility Management, the Sustainability
		Council, and the President’s Energy Task Force.`,
];

function Home() {
	const [activeTab, setActiveTab] = useState("1");

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};
	const newsevents = events
		.sort((a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf())
		.map((ev, i) => ({ ...ev, id: i }));
	const primaryEvents = [
		...newsevents.filter((e) => e.priority),
		...newsevents
			.filter((e) => !e.priority)
			.sort((a, b) => new Date(b.date) - new Date(a.date)),
	].slice(0, 5);
	return (
		<>
			{/* <div style={{ background: "#E21833", marginBottom: 12 }}>
				<h2
					style={{
						textAlign: "center",
						margin: 0,
						paddingBottom: 4,
						color: "white",
					}}
				>
					The{" "}
					<span
						style={{
							textDecoration: "underline",
							fontWeight: "bolder",
							fontSize: "110%",
						}}
					>
						C
					</span>
					enter for Sustainabil
					<span
						style={{
							textDecoration: "underline",
							fontWeight: "bolder",
							fontSize: "110%",
						}}
					>
						ity
					</span>{" "}
					in the Built Environment
					<br />
					<small>at the University of Maryland</small>
				</h2>
			</div> */}
			<Container fluid>
				<h2
					style={{
						textAlign: "center",
						letterSpacing: "0.1rem",
						// margin: 0,
						// paddingBottom: 4,
						// color: "white",
					}}
				>
					The{" "}
					<span
						style={{
							textDecoration: "underline",
							fontWeight: "bolder",
							fontSize: "110%",
						}}
					>
						C
					</span>
					enter for Sustainabil
					<span
						style={{
							textDecoration: "underline",
							fontWeight: "bolder",
							fontSize: "110%",
						}}
					>
						ity
					</span>{" "}
					in the Built Environment
					<br />
					<small>at the University of Maryland</small>
				</h2>
				<hr />
				<Row>
					<Col xs={12} md={{ size: 10, offset: 1 }}>
						<PreviewCarousel
							items={primaryEvents}
							action={
								<Button
									outline
									color="info"
									size="sm"
									tag={NavigationLink}
									to="/events"
									style={{ lineHeight: 1 }}
								>
									View All Events/News
								</Button>
							}
						/>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} md={{ size: 10, offset: 1 }}>
						<MaterialCard>
							<CardHeader title="The Origin of City@UMD" />
							<CardContent>
								<Typography gutterBottom>
									The Center for Sustainability in the Built Environment
									(City@UMD) was established with funding from the University of
									Maryland Provost’s Office in 2012. The Center’s mission is to
									revolutionize the physical infrastructure systems in cities.
								</Typography>
								<Typography gutterBottom>
									City@UMD research projects focus on technologies for
									sustainable improvements of public health in cities. City@UMD
									recent research activities centered on respiratory health and
									building ventilation are funded by federal agencies,
									companies, and non-profit organizations.
								</Typography>
							</CardContent>
							<CardActions
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<MaterialUIButton
									component={NavigationLink}
									to="/about"
									variant="outlined"
									disableElevation
									style={{ textTransform: "none" }}
								>
									Meet City@UMD
								</MaterialUIButton>
								<MaterialUIButton
									component={NavigationLink}
									to="/about"
									variant="outlined"
									size="small"
									style={{ textTransform: "none" }}
								>
									Alumni
								</MaterialUIButton>
							</CardActions>
						</MaterialCard>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} md={{ size: 10, offset: 1 }}>
						<div>
							<Nav tabs>
								<NavItem>
									<NavLink
										className={clsx({ active: activeTab === "1" })}
										onClick={() => {
											toggle("1");
										}}
									>
										Lab Office
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={clsx({ active: activeTab === "2" })}
										onClick={() => {
											toggle("2");
										}}
									>
										ME Office
									</NavLink>
								</NavItem>
							</Nav>
							<TabContent
								activeTab={activeTab}
								style={{ backgroundColor: "#fff" }}
							>
								<TabPane tabId="1">
									<Row>
										<Col sm="2">
											<img
												className="img-responsive img-logo"
												src={`${process.env.PUBLIC_URL}/umd_logo.png`}
												alt=""
											></img>
										</Col>
										<Col sm="8">
											<h3
												className="text-center"
												style={{ marginTop: 8, paddingTop: 5 }}
											>
												Technology Ventures Building
											</h3>

											<p className="text-center">
												Suite 4403, 5000 College Ave.
												<br />
												College Park, MD 20740-3809 <br />
												Office: (301) 405-6247 | Conference: (301)-405-0493
												<br />
												<a href="mailto:city@umd.edu">city@umd.edu</a>
											</p>
											<hr style={{ width: "50%", margin: "auto" }} />
											<p className="text-center">
												<a href="https://docs.google.com/document/d/1EGFz1ianCWcH1esYZl6SFv4D7hNinhpDWpyZYiIUPnY/edit?usp=sharing">
													Visitor Instructions
												</a>
												<br />
												<a
													href="https://giving.umd.edu/giving/fund.php?name=cityumd-gift-fund "
													target="_blank"
												>
													Donate to City@UMD
												</a>
											</p>
										</Col>
										<Col sm="2">
											<img
												className="img-responsive img-logo"
												src={`${process.env.PUBLIC_URL}/images/logo_match.png`}
												alt=""
											></img>
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="2">
									<Row>
										<Col sm="2">
											<img
												className="img-responsive img-logo"
												src={`${process.env.PUBLIC_URL}/umd_logo.png`}
												alt=""
											></img>
										</Col>
										<Col sm="8">
											<h3
												className="text-center"
												style={{ marginTop: 8, paddingTop: 5 }}
											>
												The University of Maryland
											</h3>
											<p className="text-center">
												3143 Glenn L. Martin Hall
												<br />
												College Park, MD 20742 <br />
												(301) 405-6247
												<br />
												<a href="mailto:city@umd.edu">city@umd.edu</a>
											</p>
											<hr style={{ width: "50%", margin: "auto" }} />
											<p className="text-center">
												<a href="https://docs.google.com/document/d/1EGFz1ianCWcH1esYZl6SFv4D7hNinhpDWpyZYiIUPnY/edit?usp=sharing">
													Visitor Instructions
												</a>
												<br />
												<a
													href="https://giving.umd.edu/giving/fund.php?name=cityumd-gift-fund "
													target="_blank"
												>
													Donate to City@UMD
												</a>
											</p>
										</Col>
										<Col sm="2">
											<img
												className="img-responsive img-logo"
												src={`${process.env.PUBLIC_URL}/images/logo_match.png`}
												alt=""
											></img>
										</Col>
									</Row>
								</TabPane>
							</TabContent>
						</div>
					</Col>
				</Row>
			</Container>
		</>
	);
}
export default Home;
